export default __webpack_public_path__ + "static/media/bannerSlider.c39f95c0.png";